/**
 * Top-bar "⋯ more tools" menu — Phase 6a-2 commit 7 of the decomposition
 * (briefs/ARCHITECTURE_DECOMPOSITION_BLUEPRINT.md §6, A39, v2.6/R22).
 * Body moved VERBATIM from static/index.html's parse-time IIFE.
 *
 * Zero-context by full-read verification (the only panel that is): it touches
 * only its own static #tb-more-btn / #tb-more-menu markup plus document/window
 * browser globals. Invoke at the original parse-time position — its
 * document-level click/keydown registration order is behaviour (rule 4).
 */

export function initMoreMenu(): void {
  const btn = document.getElementById('tb-more-btn');
  const menu = document.getElementById('tb-more-menu');
  if (!btn || !menu) return;
  const close = () => { menu.style.display = 'none'; };
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (menu.style.display === 'block') { close(); return; }
    const r = btn.getBoundingClientRect();
    menu.style.top = (r.bottom + 6) + 'px';
    menu.style.right = Math.max(8, Math.round(window.innerWidth - r.right)) + 'px';
    menu.style.display = 'block';
  });
  // Keep clicks inside the menu from reaching the document outside-click
  // handler (so interacting with the date field doesn't close the menu).
  menu.addEventListener('click', (e) => e.stopPropagation());
  // Close after a real button action. Direct per-button listeners fire even
  // when a button stops propagation (e.g. #layouts-btn), and run after the
  // button's own handler (registered earlier). The date field is an <input>,
  // excluded here, so the menu stays open while the user picks a date.
  menu.querySelectorAll('button').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('click', (e) => {
    if (menu.style.display === 'block' && !menu.contains(e.target as Node) && e.target !== btn) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.style.display === 'block') close(); });
}
